import React, { useEffect, useState } from "react";
import "./BeneficiaryCard.css";
import { Button } from "components/Buttons";
import ShowToast from "components/ShowToast";
import { getAllBanks, moneyTransferAction } from "service/Auth.services";
import APP_CONFIG, { MONEY_TRANSFER_ACTION, MONEY_TRANSFER_ACTION_AIRTEL } from "constants/app";
import { fetchWrapper } from "utils/apiFetch";

const tabsNames = ["Beneficiary List", "Add Beneficiary"];


const BeneficiaryCardAirtel = ({
  bankData,
  setBankData,
  bankOptions ,
  phone,
  userId,
  location,
  onSelectBeneficiary
}) => {
 const fields = [
   { id: "bank_name", label: "Bank name", name: "bank_name" },
    { id: "ifsc", label: "IFSC Code", name: "ifsc" },
    { id: "accountNo", label: "Account Number", name: "accountNo" },
  { id: "beneName", label: "Beneficiary Name", name: "beneName" },
  
 
 
];


  const [selectedTab, setSelectedTab] = useState("Beneficiary List");
  const [selectedValue, setSelectedValue] = useState("");
 
  const [formData, setFormData] = useState({
    bank_name: "",
    ifsc: "",
  beneName: "",
  accountNo: ""
  
  
});

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [fromListClick, setFromListClick] = useState(false); // NEW
const [bankApiData, setBankApiData] = useState([]);
const [bankSearch, setBankSearch] = useState("");
const [showBankDropdown, setShowBankDropdown] = useState(false);

  const getAllBanks = async () => {
  try {
    const res = await fetchWrapper(`https://api.mokshiq.in/soft_bank_list`);
    return await res.data || [];
  } catch (err) {
    return [] ;
  }
};
useEffect(() => {
  async function loadBanks() {
    const res = await getAllBanks();
    if (res) {
      setBankApiData(res);
    }
  }
  loadBanks();
}, []);
const filteredBanks = bankApiData.filter((bank) =>
  bank.name?.toLowerCase().includes(bankSearch.toLowerCase())
);
const handleBankSelect = (bank) => {
  setFormData((prev) => ({
    ...prev,
    bank_name: bank.name,
    ifsc: bank.ifsc || ""
  }));

  setBankSearch(bank.name);
  setShowBankDropdown(false);
};


const filteredBeneficiaries = bankData?.data?.data?.filter((item) => {
  if (!searchTerm) return true;

  const term = searchTerm.toLowerCase();

  return (
    item.customerMobile?.toLowerCase().includes(term) ||
    item.beneName?.toLowerCase().includes(term) ||
    item.bankName?.toLowerCase().includes(term) ||
    item.account?.toLowerCase().includes(term)
  );
});



 useEffect(() => {
  console.log("bankData:", bankData);
}, [bankData]);


  const handleChange = async (e) => {
    const { name, value } = e.target;
    let updatedValue = name === "phone" ? value.replace(/\D/g, "") : value;

    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
  };
async function refreshBeneficiaryList(phoneNumber) {
    const formData = new FormData();
    formData.set("userid", userId);
    formData.set("action", "SearchCustomer");
    formData.set("dmt","dmt1");
    formData.set("phone", phoneNumber);

    const res = await moneyTransferAction(formData, MONEY_TRANSFER_ACTION_AIRTEL.SEARCH_CUSTOMER);

    if (!res || !res.status) {
      ShowToast(res.data ||  "No Data Found", "danger");
    } else if (res?.status) {
      ShowToast(res.data ||"Details found", "success");
      
      setBankData(res);
      
    }
    return res;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    

    const _formData = new FormData();
    _formData.set("userid", userId);
    _formData.set("action", "AddBene");
    _formData.set("dmt", "dmt1");
    _formData.set("BeneName", formData.beneName);
    _formData.set("AccountNo", formData.accountNo);
    _formData.set("MobileNo", phone);
    _formData.set("BankCode","");
    _formData.set("IFSCCode", formData.ifsc);
    _formData.set("Customer", "");
    _formData.set("BankName", formData.bank_name);

    const res = await moneyTransferAction(_formData, MONEY_TRANSFER_ACTION_AIRTEL.SEARCH_CUSTOMER);
    if (!res || !res.status) {
      ShowToast(res.data||"No Data Found", "danger");
    } else if (res?.status) {
      ShowToast(res.data||"Details found", "success");
      await refreshBeneficiaryList(phone);

  // 👉 Switch back to list tab
  setSelectedTab("Beneficiary List");

  // 👉 Reset form
  resetBeneficiaryFormHandler();
    }
    return res;
  };

 

  const resetBeneficiaryFormHandler = () => {
    setFormData({
      userId,
      beneName: "",
  accountNo: "",
  ifsc: "",
  bank_name: ""

      
    });
    setFromListClick(false); // <-- NEW
  };

  return (
    <div className="card">
      <div className="card-header beneficiary-header">
         <ul className="nav beneficiary-tabs" role="tablist">
    {tabsNames.map((tab) => (
      <li className="nav-item" role="presentation" key={tab}>
        <button
          type="button"
          className={`nav-link ${
            selectedTab === tab ? "active" : ""
          }`}
          onClick={() => setSelectedTab(tab)}
        >
          {tab}
        </button>
      </li>
    ))}
  </ul>
        <div className="beneficiary-header-bottom">
    <h5 className="beneficiary-title">{selectedTab}</h5>

    {selectedTab === "Add Beneficiary" && (
      <Button size="sm" className="reset-btn" onClick={resetBeneficiaryFormHandler}>
        Reset
      </Button>
    )}
  </div>
      </div>

      <div className="card-body">
        {selectedTab === "Beneficiary List" && (
          <div>
            <div className="mb-3">
              <input
                aria-label="Search"
                className="fuzzy-search form-control search b-r-22"
                placeholder="Search..."
                type="search"
                value={searchTerm}
                onChange={handleInputChange}
              />
            </div>
            <ul className="list fuzzy-list">
           
            {filteredBeneficiaries && filteredBeneficiaries.length > 0 ? (
  filteredBeneficiaries.map((item, index) => (
    <li key={index} className=" cursor-pointer"  onClick={() => onSelectBeneficiary(item)}>
      <div className="beneficiary-card">
  <div className="beneficiary-card-content">
    
    {/* Avatar */}
    <div className="beneficiary-avatar">
      {item.customerMobile?.slice(-2)}
    </div>

    {/* Main Info */}
    <div className="beneficiary-info">
      
      <p className="beneficiary-name">
        {item.beneName || "Beneficiary"}
      </p>

      <p className="beneficiary-detail">
        <strong>Bank:</strong> {item.bankName || "N/A"}
      </p>

      <p className="beneficiary-detail">
        <strong>Account:</strong> {item.account || "N/A"}
      </p>

      <p className="beneficiary-detail">
        <strong>Name:</strong> {item.beneName || "N/A"}
      </p>

    </div>
  </div>
</div>

    </li>
  ))
) : (
  <li className="text-muted text-center">
    No matching beneficiaries found
  </li>
)}

            </ul>
          </div>
        )}

        {selectedTab === "Add Beneficiary" && (
          <form
            onSubmit={handleSubmit}
            className="app-form px-3 overflowY"
            style={{ height: "40dvh" }}
          >
           

            {fields
              .filter((field) => fromListClick || field.id !== "userId")
              .map((fieldData) => (
                <div className="row mt-3" key={fieldData.id}>
                  <div className="col-md-12">
                    {fieldData.name === "bank_name" ? (
  <div className="floating-form position-relative">
    <input
      type="text"
      className="form-control"
      placeholder="Search Bank"
      value={bankSearch}
      onChange={(e) => {
        setBankSearch(e.target.value);
        setShowBankDropdown(true);
        setFormData((prev) => ({
          ...prev,
          bank_name: e.target.value
        }));
      }}
    />
    <label className="form-label">Bank Name</label>

    {showBankDropdown && filteredBanks.length > 0 && (
      <ul className="bank-dropdown">
        {filteredBanks.slice(0, 8).map((bank, i) => (
          <li
            key={i}
            className="bank-dropdown-item"
            onClick={() => handleBankSelect(bank)}
          >
            {bank.name}
          </li>
        ))}
      </ul>
    )}
  </div>
) : (

                    <div className="floating-form">
                      <input
                        type="text"
                        name={fieldData.name}
                        className="form-control"
                        placeholder={`Enter ${fieldData.label}`}
                        value={formData[fieldData.name]}
                        onChange={handleChange}
                        disabled={loading}
                        maxLength={fieldData.id === "phone" ? 10 : undefined}
                      />
                      <label className="form-label">{fieldData.label}</label>
                      {errors[fieldData.name] && (
                        <div className="error-message">
                          {errors[fieldData.name]}
                        </div>
                      )}
                    </div>)}
                  </div>
                </div>
              ))}

            {!fromListClick && (
              <div className="d-flex justify-content-end py-4">
                <Button className="ellipsis" type="submit">
                  Add Beneficiary
                </Button>
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default BeneficiaryCardAirtel;
